import Colors from "styles/colors";
import VerticalTabs from "segments/desktop/core-components/vertical-tabs/vertical-tabs";
import { isDarkTheme } from "segments/segments-service";
import AssetComponent from "components/core/asset/asset-component";
import { useMemo } from "react";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { componentStyles, TAB_LINE_HEIGHT } from "./timeline-titled-tab-tabs-component.scss";
import DefaultProps from "./default-props";

const EMPTY_ASSET_TITLE_PROPS = {
  topic: {},
  body: ""
};

const TimelineTitledTabTabsComponent = ({
  fullBackground,
  theme,
  titles,
  contentHeight,
  advancedAssetTitleConfig,
  titlesColor,
  contentGap,
  ...rest
}) => {
  const tabsWithClassNames = useMemo(
    () =>
      titles.reduce(
        (tabs, title) => [
          ...tabs,
          { tabLabel: title.tabsTitle, tabClassName: "tab-title", isDisabled: true, tabDisabledColor: titlesColor },
          ...title.tabs.map((tab) => ({ ...tab, tabClassName: "nested-tab" }))
        ],
        []
      ),
    [titles, titlesColor]
  );

  const componentHeight = useMemo(
    () => contentHeight || `${tabsWithClassNames.length * TAB_LINE_HEIGHT}px`,
    [contentHeight, tabsWithClassNames.length]
  );

  const tabsTitleRenderer = () => null;

  const tabContentRenderer = ({ asset, title }) => (
    <div className="asset-and-text" style={{ height: componentHeight.toString(), gap: contentGap }}>
      {asset && <AssetComponent {...asset} style={{ padding: `${asset?.assetVerticalPadding} 0` }} />}
      {title && (
        <div className="title-wrapper">
          <FullParagraph {...EMPTY_ASSET_TITLE_PROPS} titleClassName="asset-title" {...title} {...advancedAssetTitleConfig} />
        </div>
      )}
    </div>
  );

  return (
    <div className="timeline-titled-tabs-component" style={{ background: fullBackground && Colors[theme] }}>
      <VerticalTabs
        fullBackground={fullBackground}
        tabsTitleRenderer={tabsTitleRenderer}
        tabContentRenderer={tabContentRenderer}
        {...rest}
        tabs={tabsWithClassNames}
        isDarkTheme={isDarkTheme(theme)}
      />
      <style jsx>{componentStyles}</style>
    </div>
  );
};

TimelineTitledTabTabsComponent.defaultProps = DefaultProps;
export default TimelineTitledTabTabsComponent;
